import { usePathname } from "@utils/hook/index.hook";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { FormLabel } from "../label";

import { Button } from "@components/ui/button";
import { Checkbox } from "@components/ui/checkbox";

const SortingForm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [sorting, setSorting] = useState<string>(() => {
    return searchParams.get("ordering") || "";
  });

  const handleCheckboxChange = (value: string) => {
    setSorting((prev) => (prev === value ? "" : value));
  };

  const handleReset = () => {
    setSorting("");
    searchParams.delete("ordering");
    setSearchParams(searchParams);
  };

  const handleSubmit = () => {
    if (sorting) {
      searchParams.set("ordering", sorting);
    } else {
      searchParams.delete("ordering");
    }
    setSearchParams(searchParams);
  };

  let value = "";
  let dateValue = "";
  const pathname = usePathname();
  console.log(pathname, "pathname from sortingForm");

  switch (pathname) {
    case "industry-allies":
    case "testimonials":
      value = "name";
      dateValue = `updated_date`;
      break;
    case "faqs":
      value = "question";
      dateValue = `created_date_time`;

      break;
    case "mentors":
      value = "user__first_name";
      dateValue = `created_date_time`;
      break;
    case "careers":
      dateValue = "created_date";
      value = "title";
      break;
    case "response-contact-form":
      dateValue = "created_date";
      value = "full_name";
      break;
    case "response-request-form":
      dateValue = "created_date";
      value = "full_name";
      break;
    case "blogs-category":
      dateValue = "created_date";
      value = "name";
      break;
    case "certificate-manage-template":
      dateValue = "created_date";
      value = "title";
      break;
    case "forms":
      dateValue = "created_date";
      value = "title";
      break;
    case "blogs":
      dateValue = "created_at";
      value = "title";
      break;
    case "courses-&-batch":
      dateValue = "created_at";
      value = "name";
      break;
    case "courses-duration":
      dateValue = "created_date_time";
      value = "duration";
      break;
    case "response-enrollment":
      dateValue = "updated_date";
      value = "name";
      break;
    case "response-masterclass-enrollment":
      dateValue = "updated_date";
      value = "name";
      break;
    case "courses-categories":
      dateValue = "created_date_time";
      value = "name";
      break;
    case "payment":
      dateValue = "created_date";
      value = "student__user__first_name";
      break;
    case "custom-page":
      dateValue = "created_date";
      value = "title";
      break;
    case "invoice":
      dateValue = "created_date";
      value = "student__user__first_name";
      break;
    case "certificate-certificates":
      dateValue = "created_date_time";
      value = "student__user__first_name";
      break;
    case "forms-categories":
      dateValue = "created_date";
      value = "name";
      break;
    case "team-members":
      dateValue = "created_date";
      value = "user__first_name";
      break;
    case "student-placement":
      dateValue = "created_date";
      value = "student_name";
      break;
    case "students":
      dateValue = "updated_date";
      value = "user__first_name";
      break;
    case "response-session-inquiry":
      dateValue = "updated_date";
      value = "name";
      break;
    case "response-giveaway":
      dateValue = "updated_date";
      value = "name";
      break;
    default:
      value = "title";
      dateValue = `created_date_time`;
      break;
  }
  useEffect(() => {
    if (searchParams.get("orientation") == "drag") {
      searchParams.delete("ordering");
      setSearchParams(searchParams);
    }
  }, [searchParams]);
  return (
    <div className="row w-fit">
      {/* Date Sorting */}
      <div className="p-3 w-full border">
        <h2 className="flex text-[14px] justify-between items-center">Date</h2>
        <div className="flex gap-4">
          <div
            onClick={() => handleCheckboxChange(`${dateValue}`)}
            className="flex cursor-pointer gap-2 items-center"
          >
            <FormLabel label="Ascending" className="cursor-pointer" />
            <Checkbox
              checked={sorting === `${dateValue}`}
              className="cursor-pointer"
            />
          </div>
          <div
            onClick={() => handleCheckboxChange(`-${dateValue}`)}
            className="flex cursor-pointer gap-2 items-center"
          >
            <FormLabel label="Descending" className="cursor-pointer" />
            <Checkbox
              checked={sorting === `-${dateValue}`}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>

      {/* Name Sorting */}
      <div className="p-3 w-full border">
        <h2 className="flex text-[14px] capitalize justify-between items-center">
          {value.replace(/-|_/g, " ")}
        </h2>
        <div className="flex gap-4">
          <div
            onClick={() => handleCheckboxChange(`${value}`)}
            className="flex cursor-pointer gap-2 items-center"
          >
            <FormLabel label="Ascending" className="cursor-pointer" />
            <Checkbox
              checked={sorting === `${value}`}
              className="cursor-pointer"
            />
          </div>
          <div
            onClick={() => handleCheckboxChange(`-${value}`)}
            className="flex cursor-pointer gap-2 items-center"
          >
            <FormLabel label="Descending" className="cursor-pointer" />
            <Checkbox
              checked={sorting === `-${value}`}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="p-3 border w-full">
        <div className="flex justify-between items-center gap-4">
          <Button onClick={handleReset} variant="ghost" className="border">
            Reset
          </Button>
          <Button onClick={handleSubmit} type="submit" form="submitt">
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};
export default SortingForm;
